import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** A highlight sweeping left to right instead of the whole block pulsing. */
  shimmer?: boolean;
  /** Styles the child instead, e.g. a span where a div can't go. */
  asChild?: boolean;
}

function Skeleton({ className, shimmer = false, asChild = false, ...props }: SkeletonProps) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      className={cn(
        "rounded-md bg-gray-300",
        shimmer
          ? "relative isolate overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-gradient-to-r before:from-transparent before:via-white/60 before:to-transparent motion-reduce:before:hidden"
          : "animate-pulse",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
